import gql from 'graphql-tag';

export default gql`
  query suggestionsListRequestedChanges($suggestionsListId: ID!) {
    suggestionsList(suggestionsListId: $suggestionsListId) {
      id
      lastRequestedChanges
      lastRequestedChangesAt
    }
  }
`;
